export const GET_MENU = 'GET_MENU';
export const GET_MENU_FAILED = 'GET_MENU_FAILED';
export const SET_MENU = 'SET_MENU';
export const HANDLE_MODIFIED_MENU = 'HANDLE_MODIFIED_MENU';
export const SET_CALENDAR = 'SET_CALENDAR';
export const SET_ITEMS_TO_ALERT = 'SET_ITEMS_TO_ALERT';
export const SET_ITEMS_TO_REMOVE = 'SET_ITEMS_TO_REMOVE';
export const HANDLE_REMOVE_INACTIVE_ITEMS = 'HANDLE_REMOVE_INACTIVE_ITEMS';
